module.exports = __webpack_public_path__ + "static/media/regenland-black.f7f056bd.png";